const volley = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33561)">
      <path d="M6 4.01001C3.58 5.84001 2 8.73001 2 12C2 13.46 2.32 14.85 2.89 16.11L6 14.31V4.01001Z" fill="black" />
      <path d="M11 11.42V2.05005C9.94 2.16005 8.93 2.43005 8 2.84005V13.16L11 11.42Z" fill="black" />
      <path d="M11.9996 13.15L3.88965 17.83C4.49965 18.67 5.22965 19.42 6.06965 20.03L14.9996 14.89L11.9996 13.15Z" fill="black" />
      <path d="M13 7.96008V11.4201L21.11 16.1001C21.53 15.1701 21.81 14.1701 21.93 13.1201L13 7.96008Z" fill="black" />
      <path d="M8.07031 21.2C9.28031 21.71 10.6003 22 12.0003 22C15.3403 22 18.2903 20.35 20.1103 17.84L17.0003 16.04L8.07031 21.2Z" fill="black" />
      <path d="M21.92 10.81C21.37 6.18005 17.66 2.51005 13 2.05005V5.65005L21.92 10.81Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33561">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default volley;
